export default __webpack_public_path__ + "static/media/Z_Ziper.777d9805.mp3";